<smart-card [offset]="2" [backButton]="true">
  <div class="d-flex flex-column gap-16">
    <div class="table-header-row d-flex flex-row gap-16 justify-between">
      <h3 [innerText]="config.title | translate"></h3>
      <div class="flex-auto" [style.padding-top.px]="8">
        @if (viewOptionsFields) {
        <app-table-filter
          class="self-end"
          [filterFields]="viewOptionsFields"
          [triggerViaChange]="true"
          [filterVisible]="true"
          (filterEvent)="updateViewOptions($event)"
        >
        </app-table-filter>
        }
      </div>
      <div class="table-header-actions">
        @if (filterFields) {
        <button class="filter-toggle-btn" mat-button color="primary" (click)="toggleFilter()">
          <mat-icon>filter_alt</mat-icon><span [innerText]="'crud.filter' | translate"></span>
        </button>
        }
        <button mat-raised-button color="primary" (click)="refresh()">
          <mat-icon>sync</mat-icon><span [innerText]="'crud.refresh' | translate"></span>
        </button>
        @if (clickAdd && config.addButton.label) {
        <button
          [disabled]="config.addButton.disabled"
          mat-raised-button
          color="accent"
          (click)="clickAddWrapper()"
        >
          <mat-icon>add</mat-icon><span [innerText]="config.addButton.label | translate"></span>
        </button>
        }
      </div>
    </div>

    @if (filterFields) {
    <app-table-filter
      [filterFields]="filterFields"
      [filterVisible]="config.grid.filter.filterVisible"
      (filterEvent)="updateFilter($event)"
      (searchEvent)="refreshFromFilter()"
      (resetFilterEvent)="resetFilter()"
    >
    </app-table-filter>
    }
    <ng-container>
      <mtx-grid
        [columns]="columns"
        [data]="data.items"
        [length]="data.totalCount"
        [pageOnFront]="false"
        [sortOnFront]="config.grid.filter.sortOnFront"
        [loading]="isLoading"
        [rowStriped]="true"
        [noResultText]="'grid.no_results' | translate"
        (rowClick)="clickRowWrapper($event)"
        [rowHover]="true"
        [cellSelectable]="false"
        [pageSizeOptions]="[5, 10, 25, 50, 100]"
        (sortChange)="sortChange($event)"
        (page)="getNextPage($event)"
        [pageSize]="config.grid.paging.pageSize"
        [pageIndex]="config.grid.paging.pageIndex"
        [showPaginator]="config.grid.paging.showPaginator"
        [columnMenuButtonText]="'grid.columns_shown' | translate"
        [columnMenuHeaderText]="'grid.columnMenuHeaderText' | translate"
        [columnHideable]="true"
        [columnHideableChecked]="'show'"
        [draggable]="true"
        [showColumnMenuFooter]="true"
        [columnMenuFooterTemplate]="menuFooter"
        [showToolbar]="true"
        [showColumnMenuHeader]="true"
        [toolbarTemplate]="toolbarTpl"
        [showSidebar]="true"
        [columnResizable]="true"
        [expandable]="fieldsInExpansionTemplate.length > 0"
        [expansionTemplate]="expansionTemplate"
        [noResultText]="'grid.no_results' | translate"
      >
      </mtx-grid>
    </ng-container>
  </div>
</smart-card>
<ng-template #menuFooter> </ng-template>

<ng-template #toolbarTpl> </ng-template>

<ng-template #expansionTemplate let-row>
  <div>
    @for (field of fieldsInExpansionTemplate; track field) {
    <p>{{row[field]}}</p>
    }
  </div>
</ng-template>
